module.exports = "/_next/static/images/c807ebf59c02ba4bb5781535c3ab12ce-amazon-prime-day-desktop.jpg.webp";